
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InternetConnectionService {
  private online = window.navigator.onLine;

  private onlineStatus = new BehaviorSubject<boolean>(true);

  getOnlineStatus() {
    return this.onlineStatus.asObservable();
  }

  setOnlineStatus(isOnline: boolean) {
    this.onlineStatus.next(isOnline);
  }

  constructor(private notify: ToastrService) {
    window.addEventListener("online", () => {
      this.online = true;
      this.showOnlineAlert();
    });

    window.addEventListener("offline", () => {
      this.online = false;
      this.showOfflineAlert();
    });
  }

  isOnline(): boolean {
    return this.online;
  }

  showOnlineAlert() {
    this.notify.success("Internet Connection Restored");
  }

  showOfflineAlert() {
    this.notify.error("Error! No Internet Connection");
  }
}